export default "__VITE_ASSET__CVTHePgz__$_?url__"